<div class="media profile-media">
  <div class="media-body"><span class="me-2">{{ userName ? (userName | titlecase) : 'Admin' }}</span>
    <p class="mb-0 font-roboto">{{userRole}}</p>
  </div>
</div>